module.exports = __webpack_public_path__ + "static/media/weather.de8eda8a.webp";